'use client';

import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { BIAnalyticsService } from '@terra/ui-telemetry';
import { useAuthContext } from './AuthContext';
import type { AuthContextValue, AuthUser } from './types';

export const useAuth = (): AuthContextValue => {
  const auth = useAuthContext();
  const queryClient = useQueryClient();

  const logout = useCallback(async () => {
    queryClient.clear();
    await auth.logout();
    BIAnalyticsService.tryGetInstance()?.trackLogout();
  }, [auth, queryClient]);

  return { ...auth, logout };
};

export const useUser = (): {
  user: AuthUser | null;
  isUserLoading: boolean;
} => {
  const auth = useAuthContext();
  return { user: auth.user, isUserLoading: auth.isLoading };
};
